module.exports = __webpack_public_path__ + "media/country_flags/np-1df6c389.png";